module.exports = __webpack_public_path__ + "static/media/eject.f7a9cf87.svg";